

















































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import LeftNavigationComponent from "../Workspace/Components/LeftNavigation.vue";
import GrantSummary from './GrantSummary/summary.vue';
import FinancialReports from './Monitoring/FinancialReport.vue';
import TechnicalReports from './Monitoring/TechnicalReport.vue';
import CommunicationReports from './Monitoring/CommunicationReports.vue';
import GrantDocs from './GrantSummary/grantdocs.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { GrantData } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import GrantsActivityLog from './GrantSummary/GrantsActivityLog.vue';
import GrantAmendment from './Amendment/GrantAmendment.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "grant";

@Component({
    components: {
        LeftNavigationComponent,
        ProgressBar,
        WorkflowButtons,
        GrantSummary,
        FinancialReports,
        TechnicalReports,
        CommunicationReports,
        ValidationMessageComponent,
        GrantDocs,
        GrantsActivityLog,
        GrantAmendment
    }
})
export default class GrantSummaryComponent extends Vue {

    @State(namespace) grant!: GrantData;
    @Action("getGrant", { namespace }) getGrant: any;
    @Action("getGrantData", { namespace }) getGrantData: any;
    @Action("saveGrant", { namespace }) save: any;

    selectedKey: string = Object.keys(this.subSections.properties)[0];
    showSideBar = true;
    technicalReports: any = [];
    financialReports: any = [];
    communicationReports: any = [];
    internalReview: any = {};
    grantDataLoaded: boolean = false;
    amendments: any = [];
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    /** computed property workflow items */
    get workFlowItems() {
        return this.grant.selectedGrant.WorkflowInfo || {}
    }

    /** Return grant agreement sub sections */
    get subSections() {
        if(this.$options.parent.appSettings.EnableGrantAmendment){
            return _app.grantSummarySections;
        }
        else{
            let newObj = JSON.parse(JSON.stringify(_app.grantSummarySections));
            delete newObj['properties']['grantAmendment'];
            return newObj;
        }
        
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.selectedKey = key;
        window.location.hash = `#${this.selectedKey}`;
    }

    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    formatCurrency(val, currency) {
        return utils.formatCurrency(val, currency, this.defaultLocale);
    }

    /** update the workflow status */
    updateStatus(item) {
        this.grant.selectedGrant.WorkflowStatusId = item.StepId;
        this.grant.selectedGrant.Comments = item.Comments;
        this.grant.selectedGrant.Subject = item.Subject;
        this.grant.selectedGrant.notify = item.notify;
        this.grant.selectedGrant.IsAgreementSigned = 1;
        this.save({
            data: this.grant.selectedGrant,
            id: this.grant.selectedGrant.ApplicationId
          }).then(() => {
              this.getGrant(this.grant.selectedGrant.GrantId);              
          });
    }

    /** show the agreement form */
    showAgreement() {
        var grantId = this.grant.selectedGrant.GrantId.toString();
        this.$router.push({
            name: "grantAgreement",
            params: { grantId: grantId }
        });
    }

    /** show the readonly agreement */
    showReadOnlyAgreement() {
        var grantId = this.grant.selectedGrant.GrantId.toString();
        this.$router.push({
            name: "grantAgreementReadOnly",
            params: { grantId: grantId }
        });
    }
    
    /** show validations */
    showValidation(msgs: any) {
        this.grant.validationMessages = msgs;
        this.grant.showValidationDilog = true;
    }
    
    validationMessageClosed() {
        this.grant.showValidationDilog = false;
        this.grant.validationMessages = [];
        (this.$refs.workflowButtonRef as InstanceType<typeof WorkflowButtons>).enableAllButtons();
    }
    
    validationMessageClicked(msg: any) {
        this.grant.showValidationDilog = false;
        this.grant.validationMessages = [];    
    }

    rollback(e) {        
        this.getGrant(this.grant.selectedGrant.GrantId);
    }

    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
      if(changedRoute && changedRoute.name === 'grantSummary') {

        //this.selectedTopMenu =  this.application.selectedItem;
        if(this.$route.hash)
          this.selectedKey = this.$route.hash.substr(1);
        else
          window.location.hash = `#${this.selectedKey}`;

        if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.grantId !== previousRoute.params.grantId ) {
            
            const grantId = changedRoute.params.grantId;
            this.getGrant(grantId).then((resp) => {
                if(resp) {
                    this.getGrantData(grantId).then((data) => {
                        this.grantDataLoaded = true;
                    });
                }
            });

            // list technical reports
            this.$services.monitor.listTechnicalReports(grantId)
            .then((resp: any) => {
                if(resp.Result === 'OK') {
                    this.technicalReports = resp.Record;
                }
            });  

            // list financial reports
            this.$services.monitor.listFinancialReports(grantId)
            .then((resp: any) => {
                if(resp.Result === 'OK') {
                    this.financialReports = resp.Record;
                }
            });
            
            // list financial reports
            this.$services.monitor.listCommunicationReports(grantId)
            .then((resp: any) => {
                this.communicationReports = resp;
            });
        }
      }
    }
}
